export default __webpack_public_path__ + "static/media/quesoCheddar.49ee763c.png";